// extracted by mini-css-extract-plugin
export default {"top":"SpringPaywall_top__Gjy0o"};